import { useParams } from 'react-router-dom';

const Dashboard = () => {
    const { module } = useParams();

    return (
        <div>
            <h2>{module.toUpperCase()} Module</h2>
            <p>This is the dashboard for the {module} module.</p>
        </div>
    );
};

export default Dashboard;
